import React from "react";

export default function ExampleGet() {
    let [data, setData] = React.useState('');

    const params = new URLSearchParams();
    params.append('keyword', 'Dogs');
    fetch('/get?' + params, {
        method: 'GET'
    }).then(response =>{
        return response.text()
    }).then(result => {
        setData(result)
    }).catch(err => {
        alert(err)
    });

    return (
    <main>
        <h1>Test Get From API</h1>
        <div className="mt-3">TEST GET  {data}</div>
    </main>
    );
} 